<template>
  <div class="events-page">
    <section class="intro-sm-section section-spacing">
      <div class="container mt-5">
        <div class="row d-flex justify-content-between">
          <div class="col-md-6 col-xl-6">
            <div class="ab-right">
              <div class="live-events-txt">Live events for study abroad aspirants.</div>
            </div>
            <p class="live-events-txt2">
              Hear from expert speakers
            </p>
            <div class="row">
                <div class="col">
                    <div>
                        <img
                        src="@/assets/imgs/events-page/live.png"
                        class="img-fluid live-img"
                        />
                    </div>
                    <div class="live-events-txt3">Hear from top experts & speakers</div>
                </div>
                <div class="col">
                    <div>
                        <img
                        src="@/assets/imgs/events-page/gift-card.png"
                        class="img-fluid live-img"
                        />
                    </div>
                    <div class="live-events-txt3">Exclusive goodies for attendees</div>
                </div>
                <div class="col">
                    <div>
                        <img
                        src="@/assets/imgs/events-page/free-shop.png"
                        class="img-fluid live-img"
                        />
                    </div>
                    <div class="live-events-txt3">access knowledge for free</div>
                </div>
            </div>
          </div>
          <div
            class="col-md-5 col-lg-5 d-flex justify-content-center abroad-admission-img"
          >
            <img
              src="@/assets/imgs/events-page/live_event.png"
              class="img-fluid border-all"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "EventsPage",
  metaInfo: {
    meta: [
        {
            name: "google-site-verification",
            content: "3AGVH8g4t8ldh8KcqAO8Ma3VnobGTNb-DxQdFoUQBTE"
        },
        { name: "msvalidate.01", content: "6E33F85EB785616D955B091C77828158" }
        ]
    },

    data(){
        return {

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/EventsPage.vue